/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;
const { colors } = themeVariables;

export const videoSlide = css`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* Black letterbox/pillarbox bars behind the poster and the fading-in player. */
  background-color: #000;
`;

export const poster = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const player = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  /* Hide the player's own controls and let clicks pass through to the slide wrapper. */
  --controls: none;
  pointer-events: none;
  transition: opacity 400ms ease;
`;

const controlButton = css`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: var(${colors.surface.default});
  color: var(${colors.content.default});
  cursor: pointer;
`;

export const playPauseButton = css`
  ${controlButton}
  top: 50%;
  left: 50%;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);
  transition: opacity 400ms ease;

  /* An 80px tap target around the 48px circle, for a thumb aiming at a moving video. */
  &::before {
    content: '';
    position: absolute;
    inset: -16px;
    border-radius: 50%;
  }

  /* Faded, not removed: it stays in the tab order, and shows again when focused. Taps pass
     through to the video while it is faded, so the first tap brings it back rather than
     pausing a video the customer cannot see a control for. */
  &[data-visible='false']:not(:focus-visible) {
    opacity: 0;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

/* Bottom right, because the image counter has the bottom-left corner. */
export const expandButton = css`
  ${controlButton}
  right: ${spacing.md}px;
  bottom: ${spacing.md}px;
  width: 44px;
  height: 44px;
`;
